import { useHistory, useLocation } from "react-router";
import {
    LocationState,
    LocationStateBuilder,
    PopupType,
} from "../../../types/state/ui/LocationState";
import StartEvalPopup from "./StartEvalPopup";
import { routes } from "../../../constants";
import { usePopupOrder } from "../../../effects/usePopupOrder";
import { useEffect } from "react";

export function StartEvalPopupGlobal() {
    const history = useHistory<LocationState>();
    const locationState = useLocation<LocationState>().state;
     const { canShow, markAsShown } = usePopupOrder('EvalStart');

     useEffect(() => {
        if(canShow) {
            history.push({
                ...history.location,
                state: new LocationStateBuilder(history.location.state)
                    .popup(PopupType.EvalTrial)
                    .result(),
            });
        }
     }, [canShow, history])

    if (locationState?.popup?.type !== PopupType.EvalTrial) return null;

    const handleClose = (isSubmitClose = false) => {
        history.replace({
            ...history.location,
            state: new LocationStateBuilder(history.location.state)
                .resetPopup()
                .result(),
        });

        markAsShown();

        if (isSubmitClose && history.location.pathname !== routes.eval) {
            history.push(routes.eval);
        }
    };

    return <StartEvalPopup onClose={handleClose} />;
}
